<template>
  <div>
    <el-dialog title="选择供应商分类" width="1200px" class="dialog-wrap form-module" :visible.sync="dialogvisible" :close-on-click-modal="false" :before-close="handleClose">
      <div class="default-form-title">
        <el-button type="primary" @click.stop="handleClose">关闭</el-button>
        <el-button type="primary" @click="saveData">保存</el-button>
      </div>
      <div class="">
        <el-container>
          <el-aside width="20%" id="side" style="height: 600px">
            <div class="default-form-title">选择分类(请选择到最末一级)</div>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            <el-tree
              accordion
              :data="tableData"
              :props="treeprops"
              node-key="id"
              ref="tree"
              show-checkbox
              :default-expand-all="true"
              :check-strictly="true"
              @check-change="handleCheckChange"
              :filter-node-method="filterNode"
            ></el-tree>
          </el-aside>
          <el-main id="main">
            <div class="default-form-title">已选分类</div>
            <el-table :data="tableData2" style="width: 100%" height="600">
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column label="一级分类" prop="firstName"> </el-table-column>
              <el-table-column label="二级分类" prop="secondName"> </el-table-column>
              <el-table-column label="三级分类" prop="supplierTypeName"> </el-table-column>
              <el-table-column label="说明" prop="remark"> </el-table-column>
              <!-- <el-table-column align="right">
                    <template slot="header" slot-scope="scope">
                        <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
                        
                    </template>
                </el-table-column> -->
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  props: {
    tableData: {
      type: Array
    },
    tableData1: {
      type: Array
    },
    dialogvisible: {
      type: Boolean,
      default: false
    },
    selectSupplierType: {
      type: Array
    }
  },
  data() {
    return {
      tableData2: [],
      search: '',
      treeprops: {
        label: 'name',
        Child: 'children'
      },
      filterText: ''
    }
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:dialogvisible', false)
    },
    saveData() {
      this.$emit('update:selectSupplierType', this.tableData2)
      this.$emit('update:dialogvisible', false)
    },
    handleCheckChange(data, checked, indeterminate) {
      var selectData = this.$refs.tree.getCheckedNodes()
      this.tableData2 = []
      selectData.forEach((item) => {
        var data = this.tableData1.filter((item1) => {
          return item.id == item1.paramItemCode
        })
        data.forEach((item) => {
          this.tableData2.push(item)
        })
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }
  }
}
</script>
<style scoped lang="scss">
.default-form-title {
  height: 31px;
  line-height: 31px;
  padding-left: 10px;
  font-weight: bold;
  border-bottom: 1px solid;

  .title {
    display: inline-block;
    text-indent: 15px;
    margin-left: 3px;
    margin-right: 3px;
  }

  .el-button {
    float: right;
    height: 24px;
    line-height: 10px;
    margin: 4px 8px 0;
  }

  .hideBtn {
    float: right;
    margin: 0 16px 0 8px;
    cursor: pointer;
  }
}
</style>